<template>
  <div class="page-content">
    <div class="withdrawal-container">
      <h1 class="withdrawal-title">EU Malliperuuttamislomake</h1>
      
      <div class="withdrawal-content">
        <div class="withdrawal-notice">
          <div class="notice-icon">ℹ️</div>
          <div class="notice-text">
            <p><strong>Huomio:</strong> Tämä lomake on saatavilla EU-kuluttajaoikeuksien mukaisesti. 
            Raviremmin Premium-palvelussa peruuttamisoikeus menetetään kuitenkin välittömän aktivoinnin vuoksi.</p>
          </div>
        </div>

        <div class="form-section">
          <h2>Peruuttamislomake</h2>
          <p class="form-instruction">
            Täytä ja palauta tämä lomake vain, jos haluat peruuttaa sopimuksen.
          </p>

          <div class="form-content">
            <div class="form-field">
              <label><strong>Vastaanottaja:</strong></label>
              <div class="field-content">
                RemmiGames Oy<br>
                Y-tunnus: 3541024-5<br>
                Sähköposti: info@raviremmi.com
              </div>
            </div>

            <div class="form-field">
              <label><strong>Ilmoitan peruuttavani sopimuksen seuraavan tavaran myynnistä / seuraavan palvelun suorittamisesta:</strong></label>
              <div class="field-content form-input">
                Raviremmi Premium-palvelu (3,20€)
              </div>
            </div>

            <div class="form-field">
              <label><strong>Tilattu (*) / vastaanotettu (**):</strong></label>
              <div class="field-content form-input">
                ___ / ___ / ______
              </div>
            </div>

            <div class="form-field">
              <label><strong>Kuluttajan nimi:</strong></label>
              <div class="field-content form-input">
                ________________________________
              </div>
            </div>

            <div class="form-field">
              <label><strong>Kuluttajan osoite:</strong></label>
              <div class="field-content form-input">
                ________________________________<br>
                ________________________________<br>
                ________________________________
              </div>
            </div>

            <div class="form-field">
              <label><strong>Kuluttajan allekirjoitus (vain jos lomake toimitetaan paperilla):</strong></label>
              <div class="field-content form-input">
                ________________________________
              </div>
            </div>

            <div class="form-field">
              <label><strong>Päivämäärä:</strong></label>
              <div class="field-content form-input">
                ___ / ___ / ______
              </div>
            </div>
          </div>

          <div class="form-footer">
            <p class="form-note">
              <strong>(*)</strong> Palvelujen osalta<br>
              <strong>(**)</strong> Tavaroiden osalta
            </p>
          </div>
        </div>

        <div class="instructions-section">
          <h2>Ohjeet</h2>
          <div class="instruction-item">
            <h3>1. Lomakkeen täyttäminen</h3>
            <p>Täytä lomake huolellisesti ja toimita se meille sähköpostitse osoitteeseen info@raviremmi.com</p>
          </div>
          
          <div class="instruction-item">
            <h3>2. Raviremmi Premium -erityishuomio</h3>
            <p>
              <strong>Tärkeää:</strong> Raviremmi Premium -palvelussa peruuttamisoikeus menetetään välittömästi, 
              kun palvelu aktivoidaan tilauksen yhteydessä. Tämä lomake on saatavilla EU-lainsäädännön vaatimusten mukaisesti, 
              mutta käytännössä peruuttaminen ei ole mahdollista aktivoinnin jälkeen.
            </p>
          </div>

          <div class="instruction-item">
            <h3>3. Yhteystiedot</h3>
            <p>
              Jos sinulla on kysyttävää peruuttamisoikeudesta tai tästä lomakkeesta, 
              voit ottaa yhteyttä sähköpostitse: 
              <a href="mailto:info@raviremmi.com" class="contact-link">info@raviremmi.com</a>
            </p>
          </div>
        </div>

        <div class="download-section">
          <h2>Lataa lomake</h2>
          <p>Voit myös tulostaa tämän lomakkeen täyttääksesi sen käsin:</p>
          <button @click="printForm" class="download-btn">
            🖨️ Tulosta lomake
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WithdrawalForm',
  methods: {
    printForm() {
      window.print();
    }
  }
}
</script>

<style scoped>
.page-content {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.withdrawal-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.withdrawal-title {
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #64ffda;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.withdrawal-content {
  background: #112240;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 10px 30px -15px rgba(2, 12, 27, 0.7);
  border: 1px solid #1e3a5f;
  color: #a8b2d1;
  line-height: 1.6;
}

.withdrawal-notice {
  display: flex;
  gap: 1rem;
  background-color: rgba(255, 184, 108, 0.1);
  border-left: 4px solid #ffb86c;
  padding: 1.25rem;
  border-radius: 8px;
  margin-bottom: 2rem;
}

.notice-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.notice-text p {
  margin: 0;
  color: #e6f1ff;
}

.form-section {
  margin-bottom: 2rem;
}

.form-section h2 {
  color: #e6f1ff;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #1e3a5f;
}

.form-instruction {
  font-style: italic;
  color: #8892b0;
  margin-bottom: 1.5rem;
}

.form-content {
  background-color: #1e3a5f;
  padding: 1.5rem;
  border-radius: 8px;
  border: 1px solid rgba(100, 255, 218, 0.1);
}

.form-field {
  margin-bottom: 1.5rem;
}

.form-field:last-child {
  margin-bottom: 0;
}

.form-field label {
  display: block;
  color: #e6f1ff;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.field-content {
  color: #a8b2d1;
}

.form-input {
  background-color: rgba(100, 255, 218, 0.05);
  border: 1px solid rgba(100, 255, 218, 0.2);
  border-radius: 4px;
  padding: 0.75rem;
  font-family: monospace;
  font-size: 0.9rem;
}

.form-footer {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(100, 255, 218, 0.1);
}

.form-note {
  font-size: 0.85rem;
  color: #8892b0;
  font-style: italic;
}

.instructions-section {
  margin-bottom: 2rem;
}

.instructions-section h2 {
  color: #e6f1ff;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #1e3a5f;
}

.instruction-item {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: #1e3a5f;
  border-radius: 8px;
  border: 1px solid rgba(100, 255, 218, 0.1);
}

.instruction-item h3 {
  color: #64ffda;
  font-size: 1.1rem;
  margin-bottom: 0.75rem;
}

.instruction-item p {
  margin: 0;
}

.contact-link {
  color: #64ffda;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.contact-link:hover {
  color: #ffffff;
  text-decoration: underline;
}

.download-section {
  text-align: center;
}

.download-section h2 {
  color: #e6f1ff;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #1e3a5f;
}

.download-btn {
  background-color: #64ffda;
  color: #0a192f;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.download-btn:hover {
  background-color: #52d6c0;
  transform: translateY(-2px);
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
}

/* Print styles */
@media print {
  .page-content {
    max-width: none;
    padding: 0;
  }
  
  .withdrawal-content {
    background: white;
    color: black;
    box-shadow: none;
    border: 1px solid #000;
  }
  
  .withdrawal-notice,
  .instructions-section,
  .download-section {
    display: none;
  }
  
  .form-content {
    background: white;
    border: 1px solid #000;
  }
  
  .form-field label {
    color: black;
  }
  
  .field-content {
    color: black;
  }
  
  .form-input {
    background: white;
    border: 1px solid #000;
  }
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .withdrawal-title {
    font-size: 1.8rem;
  }
  
  .withdrawal-content {
    padding: 1.5rem;
  }
  
  .form-content {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .withdrawal-content {
    padding: 1rem;
  }
  
  .withdrawal-notice {
    flex-direction: column;
    text-align: center;
  }
}
</style>
